import React, { Component } from 'react';
import { connect } from 'react-redux';
import Table from 'components/shared/table';
import { routes } from 'constants/config';
import { Icon } from 'ui';
import request from 'utils/request_ajax';
import { getStatusText } from '../../helpers.js';
import AttendanceRowPopover from './AttendanceRowPopover';

class AttendanceRow extends Component {
  state = {
    popoverOpen: false,
  };

  togglePopover = () => {
    const { popoverOpen } = this.state;
    this.setState({
      popoverOpen: !popoverOpen,
    });
  };

  changeAttendanceStatus = status => {
    const { event, attendance, updateAttendance } = this.props;
    const url = routes.IN_PERSON_TRAINING.UPDATE_EVENT_ATTENDANCES(
      event.id,
      attendance.id,
    );
    request
      .putJSON(url, {
        status,
      })
      .then(({ attendance: updatedAttendance, success }) => {
        if (success) {
          updateAttendance(updatedAttendance);
          this.togglePopover();
        }
      });
  };

  removeAttendance = () => {
    const { attendance, updateAttendance } = this.props;
    const url = routes.IN_PERSON_TRAINING.SESSION_ATTENDANCE(
      // because we're pushing data returned from SearchResults/index.jsx#addGuestAttendance
      // into the collection of attendances when searching , the newly added objects
      // will have a different shape (session.id) than that of existing ones (session_id)
      attendance.session_id || attendance.session.id,
      attendance.id,
    );
    request.delete(url).then(({ success }) => {
      if (success) updateAttendance();
    });
  };

  render() {
    const { popoverOpen } = this.state;
    const {
      attendance: { status, user },
      showAttendanceDropdown,
      isMultiSession,
    } = this.props;
    return (
      <Table.Row className="AttendanceRow">
        <Table.Body.Cell size="xl" contentClassName="d-f jc-sb fd-r">
          <span>{user.name}</span>
          <div className="d-f jc-c ai-c">
            <div className="fw-b">{getStatusText(status)}</div>
            {showAttendanceDropdown && !isMultiSession && (
              <div className="ml-16 pos-r">
                <button
                  type="button"
                  onClick={this.togglePopover}
                  className="u-resetBtn AttendanceRowActions"
                >
                  <Icon name="ellipsis-v" />
                </button>
                {popoverOpen && (
                  <AttendanceRowPopover
                    removeAttendance={this.removeAttendance}
                    changeAttendanceStatus={this.changeAttendanceStatus}
                    status={status}
                    hide={this.togglePopover}
                  />
                )}
              </div>
            )}
          </div>
        </Table.Body.Cell>
      </Table.Row>
    );
  }
}

const mapStateToProps = state => ({
  event: state.event,
  showAttendanceDropdown: !state.event.is_archived,
});

export default connect(mapStateToProps)(AttendanceRow);
